import { MaterializedSegmentLoadJobFragment } from '@spotify/confidence-graphql';

export const formatDuration = (ms: number): string => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`;
  }
  return `${seconds}s`;
};

export const formatFalsePositiveRate = (rate: number): string => {
  if (rate <= 0) return '0% of';
  if (rate >= 0.01) return `${(rate * 100).toFixed(1)}% of`;
  const ratio = Math.round(1 / rate);
  return `1 in ${ratio.toLocaleString()}`;
};

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(1)} MB`;
};

export const getTotalDuration = (
  loadJob: MaterializedSegmentLoadJobFragment,
): number | null => {
  const createTime = new Date(loadJob.createTime).getTime();
  const bloomFilterEndTime = loadJob.bloomFilterStatus?.bloomFilterEndTime
    ? new Date(loadJob.bloomFilterStatus.bloomFilterEndTime).getTime()
    : null;
  const ingestionEndTime = loadJob.ingestionStatus?.ingestionEndTime
    ? new Date(loadJob.ingestionStatus.ingestionEndTime).getTime()
    : null;
  const exportEndTime = loadJob.exportEndTime
    ? new Date(loadJob.exportEndTime).getTime()
    : null;

  if (bloomFilterEndTime) {
    return bloomFilterEndTime - createTime;
  }
  if (ingestionEndTime) {
    return ingestionEndTime - createTime;
  }
  if (exportEndTime) {
    return exportEndTime - createTime;
  }
  return null;
};
